import { SurfaceRole } from 'graphql/types';
import { useTranslation } from 'i18n';

export type SurfaceRolesMap = {
  [key in SurfaceRole]: string;
};

export default function useSurfaceRolesMap(): SurfaceRolesMap {
  const { t } = useTranslation();

  return {
    [SurfaceRole.Owner]: t('Owner'),
    [SurfaceRole.Admin]: t('Admin'),
    [SurfaceRole.Editor]: t('Editor'),
    [SurfaceRole.FilerLinker]: t('Filler-Linker'),
    [SurfaceRole.Linker]: t('Linker'),
    [SurfaceRole.Filler]: t('Filler'),
    [SurfaceRole.Viewer]: t('Viewer'),
    [SurfaceRole.RestrictedViewer]: t('Restricted-Viewer'),
  };
}
